module.exports = __webpack_public_path__ + "static/media/IE.1b45bace.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/IE.svg
// module id = 2171
// module chunks = 7